export default __webpack_public_path__ + "cbec34e46b31c5a01c1602665414184d.png";